import { useMutation, useQueryClient } from '@tanstack/react-query';
import LessonService from '../Services/lessons/LessonService';
import { toast } from 'sonner';
import { GET_LESSONS_QUERY_KEY } from '../queries/useGetLessons';

export const useLessonMutations = () => {
  const queryClient = useQueryClient();

  const createLessonMutation = useMutation({
    mutationFn: (lessonsData) => LessonService.createNewLessons(lessonsData),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_LESSONS_QUERY_KEY]);
      toast.success("Leçons créées avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la création : ${error.message}`);
    },
  });
  const updateLessonMutation = useMutation({
    mutationFn: ({ id, data }) => LessonService.updateLessonDetails(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_LESSONS_QUERY_KEY]);
      toast.success("Leçon mise à jour avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la mise à jour : ${error.message}`);
    },
  });

  const deleteLessonMutation = useMutation({
    mutationFn: (id) => LessonService.deleteLesson(id),
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([GET_LESSONS_QUERY_KEY]);
        toast.success("Leçon supprimée avec succès");
      } else {
        toast.error("Une erreur s'est produite lors de la suppression de la leçon.");
      }
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });
  const deleteLessonMediaMutation = useMutation({
    mutationFn: (id) => LessonService.deleteLessonMedia(id),
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([GET_LESSONS_QUERY_KEY]);
        toast.success("Média de la leçon supprimé avec succès");
      } else {
        toast.error("Une erreur s'est produite lors de la suppression du média de la leçon.");
      }
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });

  return {
    createLessonMutation,
    updateLessonMutation,
    deleteLessonMutation,
    deleteLessonMediaMutation,
  };
};